import { defaultEnv } from './currentEnv'
import envConstants from './envConstants'

export const API_BASE_URL_IADOCS = envConstants[defaultEnv].API_BASE_URL_IADOCS
export const URL_IASTART = envConstants[defaultEnv].URL_IASTART
export const KEYCLOAK_URL = envConstants[defaultEnv].KEYCLOAK_URL
export const KEYCLOAK_REALM = envConstants[defaultEnv].KEYCLOAK_REALM
export const KEYCLOAK_CLIENT_ID = envConstants[defaultEnv].KEYCLOAK_CLIENT_ID
